<!-- eslint-disable no-tabs -->
<template>
  <div>
    <section class="contacto">
      <div class="contacto__container">
        <div class="contacto__form">
          <h1 class="title">CONTACTO</h1>
          <!--  -->
          <form class="contact--form" v-on:submit.prevent="onSubmit">
            <label class="contact--form__label" for="Nombre" :class="{ up: name.focus || name.text !== '' }">Nombre
              Completo*</label>
            <input class="contact--form__input" type="text" name="Nombre" :class="{
              error: name.errors.length > 0 && !name.focus,
              focus: name.focus || name.text
            }" @focus="name.focus = true" @blur="validate('name'), (name.focus = false)" @input="name.errors = false"
              v-model="name.text" />
            <ul v-if="name.errors.length > 0">
              <li v-for="(error, index) in name.errors" :key="index" class="contact--form__error">
                {{ error }}
              </li>
            </ul>
            <label class="contact--form__label" for="Mail" :class="{ up: email.focus || email.text !== '' }">Correo
              electrónico*</label>
            <input class="contact--form__input" type="text" name="Mail" :class="{
              error: email.errors.length > 0 && !email.focus,
              focus: email.focus || email.text
            }" @focus="email.focus = true" @blur="validate('email'), (email.focus = false)"
              @input="email.errors = false" v-model="email.text" />
            <ul v-if="email.errors.length > 0">
              <li v-for="(error, index) in email.errors" :key="index" class="contact--form__error">
                {{ error }}
              </li>
            </ul>
            <!--  -->
            <div class="select-wrapper">
              <select v-model="country.text" class="contact--form__select" :class="{
                error:
                  country.errors.length > 0 &&
                  !country.focus,
                focus: country.focus || country.text
              }" @focus="country.focus = true" @blur="
  validate('country'), (country.focus = false)
  " @change="country.errors = false">
                <optgroup disabled hidden></optgroup>
                <option value="" selected disabled>País</option>
                <option v-for="country in optionsCountries" :key="country" :value="country">
                  {{ country }}
                </option>
              </select>

              <font-awesome-icon :icon="['far', 'angle-down']" class="icon" />
            </div>
            <ul v-show="country.errors.length > 0">
              <li v-for="(error, index) in country.errors" :key="index" class="contact--form__error">
                {{ error }}
              </li>
            </ul>
            <!--  -->
            <div class="select-wrapper">
              <select v-model="workarea.text" class="contact--form__select" :class="{
                error:
                  workarea.errors.length > 0 &&
                  !workarea.focus,
                focus: workarea.focus || workarea.text
              }" @focus="workarea.focus = true" @blur="
  validate('workarea'),
  (workarea.focus = false)
  " @change="workarea.errors = false">
                <optgroup disabled hidden></optgroup>
                <option value="" selected disabled>Rubro y asunto</option>
                <option v-for="workarea in optionsWorkAreas" :key="workarea" :value="workarea">
                  {{ workarea }}
                </option>
              </select>

              <font-awesome-icon :icon="['far', 'angle-down']" class="icon" />
            </div>
            <ul v-if="workarea.errors.length > 0">
              <li v-for="(error, index) in workarea.errors" :key="index" class="contact--form__error">
                {{ error }}
              </li>
            </ul>
            <!--  -->
            <label class="contact--form__label" for="empresa" :class="{
              up: company.focus || company.text !== ''
            }">Empresa</label>
            <input class="contact--form__input" type="text" name="empresa" :class="{
              error:
                company.errors.length > 0 && !company.focus,
              focus: company.focus || company.text
            }" @focus="company.focus = true" @blur="validate('company'), (company.focus = false)"
              @input="company.errors = false" v-model="company.text" />
            <ul v-if="company.errors.length > 0">
              <li v-for="(error, index) in company.errors" :key="index" class="contact--form__error">
                {{ error }}
              </li>
            </ul>
            <label class="contact--form__label" for="Mensaje" :class="{
              up: message.focus || message.text !== ''
            }">Mensaje</label>
            <textarea rows="5" class="contact--form__textarea" type="text" name="Mensaje" :class="{
              error:
                message.errors.length > 0 && !message.focus,
              focus: message.focus || message.text
            }" @focus="message.focus = true" @blur="validate('message'), (message.focus = false)"
              @input="message.errors = false" v-model="message.text"></textarea>
            <ul v-if="message.errors.length > 0">
              <li v-for="(error, index) in message.errors" :key="index" class="contact--form__error">
                {{ error }}
              </li>
            </ul>
            <div style="margin-top: 10px; text-align: center;">
              <vue-recaptcha @verify="recaptchaVerify" @expired="recaptchaExpired" :loadRecaptchaScript="true" language="Es" sitekey="6Lc07NYmAAAAAC-A4ia1GmX5gpEwU8khfrh2Hr_b"></vue-recaptcha>
              <span v-if="showRecaptchaMessage" style="color: #ff6347; font-size: 12px; font-family: 'Rubik',sans-serif;">Este campo es obligatorio</span>
            </div>
            <div class="contact--form__button" @click="sendForm">
              <span v-if="!sending">ENVIAR</span>
              <span v-if="sending">ENVIANDO</span>
            </div>
          </form>
        </div>

        <div class="contacto__photo">
          <img src="/img/png/contacto_new.png" />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
// eslint-disable no-tabs
import Footer from '@/shared/Footer'
import axios from 'axios'
import VueRecaptcha from 'vue-recaptcha'

export default {
  created () {
    this.windowWidth = window.innerWidth
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  mounted () {
    this.$store.commit('setScrolling', false)
  },
  data () {
    return {
      windowWidth: 0,
      sending: false,
      recaptcha: false,
      showRecaptchaMessage: false,
      name: {
        text: '',
        errors: [],
        dirty: false,
        invalid: false,
        focus: false
      },
      email: {
        text: '',
        errors: [],
        dirty: false,
        invalid: false,
        focus: false
      },
      country: {
        text: '',
        errors: [],
        dirty: false,
        invalid: false,
        focus: false
      },
      workarea: {
        text: '',
        errors: [],
        dirty: false,
        invalid: false,
        focus: false
      },
      company: {
        text: '',
        errors: [],
        dirty: false,
        invalid: false,
        focus: false
      },
      message: {
        text: '',
        errors: [],
        dirty: false,
        invalid: false,
        focus: false
      },
      optionsCountries: [
        'ARGENTINA',
        'BOLIVIA',
        'CHILE',
        'COLOMBIA',
        'COSTA RICA',
        'ECUADOR',
        'EL SALVADOR',
        'GUATEMALA',
        'HONDURAS',
        'MÉXICO',
        'NICARAGUA',
        'PANAMÁ',
        'PARAGUAY',
        'PERÚ',
        'REPUBLICA DOMINICANA',
        'URUGUAY',
        'VENEZUELA',
        'OTRO'
      ],
      optionsWorkAreas: [
        'Alimentación y bebidas',
        'Arquitectura y planificación',
        'Artículos de consumo',
        'Banca de inversiones',
        'Bienes inmobiliarios',
        'Construcción',
        'Consultoría de estrategia y operaciones',
        'Cosmética',
        'Deportes',
        'Energía renovable y medio ambiente',
        'Formación profesional y capacitación',
        'Industria farmacéutica',
        'Maquinaria',
        'Marketing y publicidad',
        'Minería y metalurgia',
        'Museos e instituciones',
        'Ocio, viajes y turismo',
        'Organización política',
        'Política pública',
        'Producción alimentaria',
        'Restaurantes',
        'Sector automovilístico',
        'Servicios financieros',
        'Servicios infraestructurales',
        'Servicios jurídicos',
        'Servicios médicos',
        'Servicios y tecnologías de la información',
        'Software',
        'Venta al por mayor',
        'Otros'
      ]
    }
  },
  components: {
    'main-footer': Footer,
    'vue-recaptcha': VueRecaptcha
  },
  methods: {
    recaptchaVerify () {
      this.recaptcha = true
      this.showRecaptchaMessage = false
    },
    recaptchaExpired () {
      this.showRecaptchaMessage = true
      this.recaptcha = false
    },
    validate (field) {
      switch (field) {
        case 'name':
          this.name.dirty = true
          this.validateName()
          break
        case 'email':
          this.email.dirty = true
          this.validateEmail()
          break
        case 'country':
          this.country.dirty = true
          this.validateCountry()
          break
        case 'workarea':
          this.country.dirty = true
          this.validateWorkArea()
          break
        case 'company':
          this.company.dirty = true
          this.validateCompany()
          break
        case 'message':
          this.message.dirty = true
          this.validateMessage()
          break
        default:
      }
    },
    validateName () {
      this.name.invalid = false
      this.name.errors = []
      if (!this.name.text) {
        this.name.invalid = true
        this.name.errors.push('Este campo es requerido')
      }
    },
    validateEmail () {
      this.email.invalid = false
      this.email.errors = []
      if (!this.email.text) {
        this.email.invalid = true
        this.email.errors.push('Este campo es requerido.')
      }
      const filter = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,66}(?:\.[a-z]{2})?)$/i
      if (this.email.text && !filter.test(this.email.text)) {
        this.email.invalid = true
        this.email.errors.push(
          'Debe ser una dirección de correo válida.'
        )
      }
    },
    validateCountry () {
      this.country.invalid = false
      this.country.errors = []
      if (!this.country.text) {
        this.country.invalid = true
        this.country.errors.push('Este campo es requerido.')
      }
    },
    validateWorkArea () {
      this.workarea.invalid = false
      this.workarea.errors = []
      if (!this.workarea.text) {
        this.workarea.invalid = true
        this.workarea.errors.push('Este campo es requerido.')
      }
    },
    validateCompany () {
      this.company.invalid = false
      this.company.errors = []
      if (!this.company.text) {
        this.company.invalid = true
        this.company.errors.push('Este campo es requerido.')
      }
    },
    validateMessage () {
      this.message.invalid = false
      this.message.errors = []
      if (!this.message.text) {
        this.message.invalid = true
        this.message.errors.push('Por favor, escribe un mensaje')
      }
    },
    sendForm () {
      this.validate('name')
      this.validate('email')
      this.validate('country')
      this.validate('workarea')
      this.validate('company')
      this.validate('message')

      if (
        this.name.invalid ||
        this.email.invalid ||
        this.country.invalid ||
        this.workarea.invalid ||
        this.company.invalid ||
        this.message.invalid || !this.recaptcha
      ) {
        this.showRecaptchaMessage = true
        this.$notify.error({
          title: 'Error',
          message: 'Debe completar los campos correctamente.',
          showClose: false
        })
        this.sending = false
      } else {
        this.sending = true

        // eslint-disable-next-line no-undef

        const formData = new FormData()
        formData.append('name', this.name.text)
        formData.append('email', this.email.text)
        formData.append('country', this.country.text)
        formData.append('workarea', this.workarea.text)
        formData.append('company', this.company.text)
        formData.append('message', this.message.text)

        axios
          .post('https://admin.circulo.digital/contact', formData)
          .then((response) => {
            if (response.data !== 'error') {
              this.sensing = false
              this.$notify.success({
                title: 'Enviado!',
                message:
                        'Su consulta ha sido enviada correctamente',
                showClose: false
              })
              this.name.text = ''
              this.email.text = ''
              this.country.text = ''
              this.workarea.text = ''
              this.company.text = ''
              this.message.text = ''

              this.$store.commit('showGraciasView', true)
              this.$router.push('/contacto/gracias')
            } else {
              this.sending = false
              this.$notify.error({
                title: 'Hubo un problema',
                message:
                        'El mensaje no puede ser enviado en este momento, intente nuevamente más tarde.',
                showClose: false
              })
            }
          })
          .catch((e) => {
            this.sending = false
            this.$notify.error({
              title: 'Error de servidor',
              message: 'Falló la conexión con el servidor.',
              showClose: false
            })
            throw new Error(e)
          })
      }
    }
  }
}
</script>
